module.exports = __webpack_public_path__ + "img/23.624b9a1d.jpg";